import { createSelector } from 'reselect';

const transactionHistorySelector = (state) => state.transaction;

export const selectTransactionHistory = createSelector(
  [transactionHistorySelector],
  (transaction) => transaction.transactionHistory
);

export const selectTransactionHistoryLoading = createSelector(
  [transactionHistorySelector],
  (transaction) => transaction.fetchingtransactionHistory
);

export const selectQueryTransactionLoading = createSelector(
  [transactionHistorySelector],
  (transaction) => transaction.isQueryingStatus
);

export const selectExportLoading = createSelector(
  [transactionHistorySelector],
  (transaction) => transaction.isExpotingData
);